import React from 'react'

import { AgGridContext } from '@/components/lemmala-design-system/table/contexts/ag-grid-context'
import { type AgGridContextValue } from '@/components/lemmala-design-system/table/types'

export function AgGridProvider<TRowData = Record<string, unknown>>(props: {
  value: AgGridContextValue<TRowData>
  children: React.ReactNode
}) {
  return (
    <AgGridContext.Provider value={props.value as AgGridContextValue}>
      {props.children}
    </AgGridContext.Provider>
  )
}
